import { FC } from 'react';
import SpinnerLoader from '../Loader/Spinner';

const Fallback: FC = () => (
    <div className='flex justify-center items-center w-screen h-screen'>
        <SpinnerLoader />
    </div>
);

export default Fallback;
